import {Language} from "../../i18n/language";
import * as wizardStyle from "../../cerahOnline/cerahOnline.module.scss";
import React from "react";
import zeroToThree from '../../../../img/cerahKids/0-3.svg'
import eightToEleven from '../../../../img/cerahKids/4-7.svg'
import fourToSeven from '../../../../img/cerahKids/8-11.svg'
import twelveToSeventeen from '../../../../img/cerahKids/12-17.svg'
import {IconChoiceButton} from "../iconChoiceButton/iconChoiceButton";

const meetingsPerWeekOptions = [
  {ageGroup: [0, 3], label: '0 - 3', icon: zeroToThree},
  {ageGroup: [4, 7], label: '4 - 7', icon: fourToSeven},
  {ageGroup: [8, 11], label: '8 - 11', icon: eightToEleven},
  {ageGroup: [12, 17], label: '12 - 15', icon: twelveToSeventeen}
];

export function ChooseAgeGroup(props) {
  const strings = Language.active.cerahKids;
  return (
    <div className={wizardStyle.choiceSection}>
      <div className={wizardStyle.choiceTitle}>{strings.whatIstheAgeOfTheStudent}</div>
      <div className={wizardStyle.buttonPanel}>

        {meetingsPerWeekOptions.map(({ageGroup, label, icon}) =>
          <IconChoiceButton key={label} onClick={() => props.onAgeGroupChosen(ageGroup)} label={label} icon={icon}/>
        )}
      </div>
    </div>
  );
}